// extracted by mini-css-extract-plugin
module.exports = {"cart":"Cart_cart__2ApFU","card":"Cart_card__33VqF","title":"Cart_title__pzHde","button":"Cart_button__UFFpv","errorDiv":"Cart_errorDiv__1bH8G","userMsg":"Cart_userMsg__3mLwW"};